import React from 'react';
import {useOrders} from '../context/OrdersContext';
import UpdateAvailableDeliverySlotModal
	from '../../../../components/UpdateAvailableDeliverySlot/UpdateAvailableDeliverySlotModal';
import API from '../../../../network/dashboardAPI';

const UpdateSlotDialog = () => {
	const {state, actions} = useOrders();
	const {updateSlotDialogOpen, selectedOrder, selectedSlotId, updatingSlot} = state;

	// Handle slot selection and update
	const handleSlotSelected = async (slotId, slot) => {
		if (!selectedOrder) return;

		actions.setUpdatingSlot(true);

		const body = {
			order_id: selectedOrder.order_id,
			slot_id: slotId,
			slot_type: slot.type,
			slot_range: slot.slot_range,
			delivered_at: selectedOrder.delivered_at,
		};

		try {
			const response = await API.updateSlotAndDeliveryAtByAdmin(body)
				.then((res) => res.json());

			if (response.success) {
				alert('Slot updated successfully');
				actions.closeUpdateSlotDialog();
				actions.setUpdatingSlot(false);

				// Refresh orders list after a short delay
				setTimeout(() => {
					actions.refreshData();
				}, 1000);
			} else {
				alert(response.message || 'Failed to update slot');
				actions.setUpdatingSlot(false);
			}
		} catch (error) {
			console.error('Update slot error:', error);
			alert('Error updating slot: ' + error.message);
			actions.setUpdatingSlot(false);
		}
	};

	const handleCloseDialog = () => {
		actions.closeUpdateSlotDialog();
	};

	if (!selectedOrder) return null;

	return (
		<UpdateAvailableDeliverySlotModal
			show={updateSlotDialogOpen}
			handleCloseDialog={handleCloseDialog}
			selectedSlot={0}
			onSlotSelected={handleSlotSelected}
			pageName="admin-orders"
			orderId={selectedOrder.order_id}
			slotId={selectedSlotId || selectedOrder.slot_id}
			order={selectedOrder}
			updatingSlot={updatingSlot}
		/>
	);
};

export default UpdateSlotDialog;
